module.exports = __webpack_public_path__ + "static/img/6e712f849c8926eb695a33e9e72ddbc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_01.png
// module id = iift
// module chunks = 1